import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Button, Grid } from "@mui/material";
import Header from "../Header/Header1";
import bannerLg from "../../Img/hbanner.png";
import bannerDK from "../../Img/hbannerDk.png";
import Footernew from "../Footer/Footernew";
import { Navigate, useNavigate } from "react-router-dom";
import { Backdrop, useMediaQuery, useTheme } from "@mui/material";
import { ThemeContext } from "../DarkMode/ThemeProvider";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import btc from "../../Img/btc.svg";
import ltc from "../../Img/ltc.svg";
import kcs from "../../Img/eth.png";

import { tableCellClasses } from "@mui/material/TableCell";
import ImageWithFallback from "../FallbackImage/ImageWithFallback";
import nodata from "../../Img/newnodta.gif";
import consts from "../../constant";
import usercalls from "../../Axios";
import chart_table from "../../Img/chart_table.png";
import $ from "jquery";

import axios from "axios";

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

const HomeNew = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { isLightMode, handleDarkmode } = useContext(ThemeContext);

  const cards2 = [
    {
      img: btc,
      coinname: "TFUEL",
    },
    {
      img: ltc,
      coinname: "AUCTION",
    },
    {
      img: kcs,
      coinname: "FET",
    },
  ];

  const cards3 = [
    {
      img: btc,
      coinname: "ETH",
    },
    {
      img: ltc,
      coinname: "BTC",
    },
    {
      img: kcs,
      coinname: "XRP",
    },
  ];
  const Subws = useRef(null);
  const subPingws = useRef(null);

  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const [collections, setCollections] = useState({
    columns: [
      {
        Header: "Tokens",
        accessor: "tokens",
        align: "left",
      },
      {
        Header: "Amount",
        accessor: "amount",
        align: "center",
      },

      {
        Header: "Price",
        accessor: "Price",
        align: "center",
      },
      {
        Header: "Change (24)",
        accessor: "Change",
        align: "center",
      },
      {
        Header: "Volume",
        accessor: "best_sell",
        align: "center",
      },
      {
        Header: "Trend",
        accessor: "trend",
        align: "center",
      },
    ],
    row: [
      {
        tokens: (
          <div className="display-1">
            <img
              src={
                "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Bitcoin.svg/1200px-Bitcoin.svg.png"
              }
              width={"50px"}
            />
            <div className="c-name">
              Bitcoin
              <div className="ast-name">BTC</div>
            </div>
          </div>
        ),
        amount: "10,000",
        Price: "1$",
        Change: <div className="clr-green">3.35%</div>,
        best_sell: "$423.5M",
        tend: (
          <svg
            width="116"
            height="35"
            viewBox="0 0 116 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.428223 16.6867L23.2854 25.3665L46.1425 34.0462L68.9996 21.0266L91.8568 12.3468L114.714 1.71411"
              stroke="#22C55E"
              stroke-width="1.61624"
            />
          </svg>
        ),
      },
      {
        tokens: (
          <div className="display-1">
            <img
              src={
                "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Bitcoin.svg/1200px-Bitcoin.svg.png"
              }
              width={"50px"}
            />
            <div className="c-name">
              Bitcoin
              <div className="ast-name">BTC</div>
            </div>
          </div>
        ),
        amount: "10,000",
        Price: "1$",
        Change: <div className="clr-green">3.35%</div>,
        best_sell: "$423.5M",
        trend: (
          <svg
            width="116"
            height="35"
            viewBox="0 0 116 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.14258 1.42871L23.9997 12.2061L46.8569 22.9834L69.714 33.7608L92.5711 22.9834L115.428 14.9004"
              stroke="#EF4444"
              stroke-width="1.61624"
            />
          </svg>
        ),
      },
      {
        tokens: (
          <div className="display-1">
            <img
              src={
                "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Bitcoin.svg/1200px-Bitcoin.svg.png"
              }
              width={"50px"}
            />
            <div className="c-name">
              Bitcoin
              <div className="ast-name">BTC</div>
            </div>
          </div>
        ),
        amount: "10,000",
        Price: "1$",
        Change: <div className="clr-green">3.35%</div>,
        best_sell: "$423.5M",
        trend: (
          <svg
            width="116"
            height="35"
            viewBox="0 0 116 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.428223 16.6867L23.2854 25.3665L46.1425 34.0462L68.9996 21.0266L91.8568 12.3468L114.714 1.71411"
              stroke="#22C55E"
              stroke-width="1.61624"
            />
          </svg>
        ),
      },
      {
        tokens: (
          <div className="display-1">
            <img
              src={
                "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Bitcoin.svg/1200px-Bitcoin.svg.png"
              }
              width={"50px"}
            />
            <div className="c-name">
              Bitcoin
              <div className="ast-name">BTC</div>
            </div>
          </div>
        ),
        amount: "10,000",
        Price: "1$",
        Change: <div className="clr-green">3.35%</div>,
        best_sell: "$423.5M",
        trend: (
          <svg
            width="116"
            height="35"
            viewBox="0 0 116 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.428223 16.6867L23.2854 25.3665L46.1425 34.0462L68.9996 21.0266L91.8568 12.3468L114.714 1.71411"
              stroke="#22C55E"
              stroke-width="1.61624"
            />
          </svg>
        ),
      },
      {
        tokens: (
          <div className="display-1">
            <img
              src={
                "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Bitcoin.svg/1200px-Bitcoin.svg.png"
              }
              width={"50px"}
            />
            <div className="c-name">
              Bitcoin
              <div className="ast-name">BTC</div>
            </div>
          </div>
        ),
        amount: "10,000",
        Price: "1$",
        Change: <div className="clr-green">3.35%</div>,
        best_sell: "$423.5M",
        trend: (
          <svg
            width="116"
            height="35"
            viewBox="0 0 116 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.428223 16.6867L23.2854 25.3665L46.1425 34.0462L68.9996 21.0266L91.8568 12.3468L114.714 1.71411"
              stroke="#22C55E"
              stroke-width="1.61624"
            />
          </svg>
        ),
      },
      {
        tokens: (
          <div className="display-1">
            <img
              src={
                "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Bitcoin.svg/1200px-Bitcoin.svg.png"
              }
              width={"50px"}
            />
            <div className="c-name">
              Bitcoin
              <div className="ast-name">BTC</div>
            </div>
          </div>
        ),
        amount: "10,000",
        Price: "1$",
        Change: <div className="clr-green">3.35%</div>,
        best_sell: "$423.5M",
        trend: (
          <svg
            width="116"
            height="35"
            viewBox="0 0 116 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.14258 1.42871L23.9997 12.2061L46.8569 22.9834L69.714 33.7608L92.5711 22.9834L115.428 14.9004"
              stroke="#EF4444"
              stroke-width="1.61624"
            />
          </svg>
        ),
      },
    ],
  });

  const [topLoosers, setTopLoosers] = useState([]);
  const [topVolume, setTopVolume] = useState([]);
  const [topGainers, setTopGainers] = useState([]);

  const [allPairs, setAllPairs] = useState([]);
  const [currentPairs, setCurrentPairs] = useState([]);
  const [oldPairs, setOldPairs] = useState([]);
  const path = usercalls();
  const getPairs = async (value) => {
    try {
      if (currentPairs) {
        // UnsubscribeStream(currentPairs)
        setOldPairs(currentPairs);
      }

      const url = `${consts.BackendUrl}/getOwnPairs?page=1&limit=10&search=${value ? value : ""
        }`;
      const response = await path.getCall({ url });
      const result = await response.json();
      if (result?.result?.totalDocs > 0) {
        // setTotalCount(result?.result?.totalDocs);
        setCurrentPairs(result?.result?.docs);
        // getAxiosPairs(result?.result?.docs)
        // subScribeStream(result?.result?.docs);
      } else {
        setCurrentPairs([]);
        // setTotalCount(0);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getPairs();
    getAxiosPairs([...cards2, ...cards3]);
  }, []);

  const getAxiosPairs = async (currentPairs) => {
    try {
      axios.withCredentials = true;
      if (currentPairs?.length > 0) {
        const symbol = currentPairs?.map((data) => data?.coinname + "-USDT");
        var data;

        const dts = await axios.post(`${consts.BackendUrl}/kucoin/gettickers`, {
          mode: "spot",
          symbol,
        });
        data = dts.data?.result;
        // console.log(data)

        if (data?.length > 0) {
          for (let i = 0; i < data?.length; i++) {
            const element = data[i];
            let priceHtml =
              parseFloat(element?.changeRate * 100).toFixed(2) > 0
                ? `<span class="green" > +${parseFloat(
                  element?.changeRate * 100
                ).toFixed(2)} %</span> `
                : `<span class="red" > ${parseFloat(
                  element?.changeRate * 100
                ).toFixed(2)} %</span> `;

            // $(`.price-${element?.symbol.split('-').join("")}`).html(isNaN(element?.last) ? '0' : Number(element?.last).toFixed(6));
            $(`.pricemarket-${element?.symbol.split("-").join("")}`).html(
              isNaN(element?.last) ? "0" : Number(element?.last).toFixed(6)
            );
            $(`.changemarket-${element?.symbol.split("-").join("")}`).html(
              priceHtml
            );
            // $(`.change-${element?.symbol.split('-').join("")}`).html(priceHtml);
            // $(`.high-${element?.symbol.split('-').join("")}`).html(isNaN(element?.high) ? '0' : Number(element?.high).toFixed(6));
            // $(`.low-${element?.symbol.split('-').join("")}`).html(isNaN(element?.low) ? '0' : Number(element?.low).toFixed(6));
            // $(`.volume-${element?.symbol.split('-').join("")}`).html(isNaN(element?.vol) ? '0' : Number(element?.vol).toFixed(2));
          }
        }
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const [kucoinToken, setKucoinToken] = useState("");

  const generateKucoinToken = async () => {
    try {
      axios.withCredentials = true;
      const url = `${consts.BackendUrl}/kucoin/generatekucointoken`;
      const { data } = await axios.get(url);
      if (data.success) {
        let str = data?.result?.replace(/^"(.*)"$/, "$1");
        setKucoinToken(str);
        // console.log(str);
      }
    } catch (err) {
      console.log(err, "error from token");
    }
  };

  const marketSocket = () => {
    try {
      const ws = new WebSocket(
        `wss://ws-api-spot.kucoin.com?token=${kucoinToken}`
      );
      Subws.current = ws;
      ws.onopen = () => {
        // Combine all cards into one array
        const allCards = [...cards2, ...cards3];

        // Create a set to store unique coin names
        const uniqueCoins = new Set();

        // Iterate over all cards and add unique coin names to the set
        allCards.forEach((card) => {
          uniqueCoins.add(card.coinname);
        });

        // Convert the set to an array and map to the desired format
        const uniqueCoinArray = Array.from(uniqueCoins).map(
          (coin) => `${coin}-USDT`
        );
        const curpar = currentPairs?.map((cp) =>
          cp.pair_symbol.split("_").join("-")
        );
        const merge = [...uniqueCoinArray, ...curpar];
        const symbols = merge.join(",");
        // console.log(s)

        const priceApicall = {
          id: new Date().getTime(),
          type: "subscribe",
          topic: `/market/snapshot:${symbols}`,
          response: true,
        };
        // const priceApicall2 = {
        //   "id": new Date().getTime(),
        //   "type": "subscribe",
        //   "topic": `/market/snapshot:${merge}`,
        //   "response": true
        // };
        ws.send(JSON.stringify(priceApicall));
        // ws.send(JSON.stringify(priceApicall2));
      };

      ws.onmessage = (event) => {
        const jsons = JSON.parse(event.data);
        const json = jsons ? jsons?.data?.data : "";
        // console.log(json,"markdata")
        try {
          let priceHtml =
            parseFloat(json?.changeRate * 100).toFixed(2) > 0
              ? `<span class="green" > +${parseFloat(
                json?.changeRate * 100
              ).toFixed(2)} %</span> `
              : `<span class="red" > ${parseFloat(
                json?.changeRate * 100
              ).toFixed(2)} %</span> `;

          $(`.pricemarket-${json?.symbol.split("-").join("")}`).html(
            isNaN(json?.lastTradedPrice)
              ? "0"
              : Number(json?.lastTradedPrice)
          );
          // $(`.change - ${ json?.s }`).html(isNaN(json?.P) ? '0' : Number(json?.P).toFixed(2) + "%");
          $(`.changemarket-${json?.symbol.split("-").join("")}`).html(
            priceHtml
          );
          $(`.price-${json?.symbol.split("-").join("")}`).html(
            isNaN(json?.lastTradedPrice)
              ? "0"
              : Number(json?.lastTradedPrice)
          );
          $(`.change-${json?.symbol.split("-").join("")}`).html(priceHtml);
          $(`.high-${json?.symbol.split("-").join("")}`).html(
            isNaN(json?.high) ? "0" : Number(json?.high)
          );
          $(`.low-${json?.symbol.split("-").join("")}`).html(
            isNaN(json?.low) ? "0" : Number(json?.low)
          );
          $(`.volume-${json?.symbol.split("-").join("")}`).html(
            isNaN(json?.vol) ? "0" : Number(json?.vol)?.toFixed(2)
          );
        } catch (error) {
          console.error("Error updating price:", error);
        }
      };
      ws.onerror = (error) => {
        console.error("WebSocket Error:", error);
      };

      ws.onclose = (e) => {
        console.log("WebSocket Connection Closed", e.code);
      };

      return () => {
        console.log("Cleaning up WebSocket connection");
        ws.close();
      };
    } catch (error) { }
  };

  useEffect(() => {
    generateKucoinToken();
  }, []);

  useEffect(() => {
    if (Subws.current) {
      Subws.current?.close();
      Subws.current = null;
    }
    marketSocket();

    subPingws.current = setInterval(() => {
      if (Subws.current?.readyState === WebSocket.OPEN) {
        const pingMsg = {
          id: `ping-${Date.now()}`,
          type: "ping",
        };
        Subws.current?.send(JSON.stringify(pingMsg));
        // console.log('Sent ping price:', pingMsg.id);
      }
    }, 20000);

    return () => {
      clearInterval(subPingws.current);
    };
  }, [currentPairs, kucoinToken]);

  // Debounced function
  const debouncedSubmit = useCallback(
    debounce((value) => {
      getPairs(value);
    }, 300), // 300ms debounce delay
    []
  );

  // Effect to call debounced function when search changes
  useEffect(() => {
    debouncedSubmit();
  }, []);

  const topGain = topGainers.map((table) => (
    <TableRow className="cursor">
      <TableCell align="center">
        <div className="display-1 coin-gap">
          {/* <div className="star-img">
                        <img src={star} alt="star" />
                    </div> */}
          {/* <div className="coin-img">
                        <img src={table?.img ? table?.img : Btc} alt="coin" />
                    </div> */}
          <div className="coin-name">
            <p> {table?.symbol}</p>
            {/* <span> {table.coinname}</span> */}
          </div>
        </div>
      </TableCell>
      <TableCell align="center">
        <div className={`pricess-${table?.symbol} grey`}>
          {table?.lastPrice}
        </div>
      </TableCell>
      <TableCell align="center" className={`24hpc-${table?.symbol} red`}>
        {table?.priceChangePercent}
      </TableCell>
      <TableCell align="center" className={`vol-${table?.symbol}`}>
        {table?.volume}
      </TableCell>
      <TableCell align="center">
        {" "}
        <img src={chart_table} alt="star" />
      </TableCell>
      {/* <TableCell align="center">
                <div className="actions" >
                    <Link to={`/trade/${table?.symbol}`}>Trade</Link>
                </div>
            </TableCell> */}
    </TableRow>
  ));

  const [status, setStatus] = useState(window.localStorage.getItem("Rikosta"));

  const getTopGainers = async () => {
    try {
      const url = `${consts.BackendUrl}/topgainers`;
      const response = await path.getCall({ url });
      const result = await response.json();

      if (result?.success) {
        // Extract symbols from top gainers, losers, and volume pairs and Formatting For webSocket
        const topGainersSymbols =
          result?.topgainers?.map(
            (item) => `${item?.symbol?.toLowerCase()}@ticker`
          ) || [];
        const topLosersSymbols =
          result?.toplosers?.map(
            (item) => `${item?.symbol?.toLowerCase()}@ticker`
          ) || [];
        const topVolumeSymbols =
          result?.topvolume?.map(
            (item) => `${item?.symbol?.toLowerCase()}@ticker`
          ) || [];

        setTopGainers(result?.topgainers);
        setTopLoosers(result?.toplosers);
        setTopVolume(result?.topvolume);
        setAllPairs([
          ...topGainersSymbols,
          ...topLosersSymbols,
          ...topVolumeSymbols,
        ]);
      }
    } catch (error) {
      console.log(error, "error getting topgainers");
    }
  };

  useEffect(() => {
    getTopGainers();
  }, []);

  const currentSocket = async () => {
    try {
      // console.log(allPairs, "allPairsallPairs");
      const ws = new WebSocket("wss://stream.binance.com:9443/ws");
      // setCurrentSoc(ws)
      ws.onopen = (event) => {
        const priceApicall = {
          method: "SUBSCRIBE",
          params: allPairs,
          id: 1,
        };
        ws.send(JSON.stringify(priceApicall));
      };

      ws.onmessage = function (event) {
        const json = JSON.parse(event.data);
        // console.log(json, "jsonevent");
        try {
          $(`.pricess-${json?.s}`).html(
            `<span class=${Number(json?.P).toFixed(2) > 0 ? "tr-green" : "tr-red"
            } >${Number(json?.c).toFixed(4)}</span>`
          );
          $(`.24hp-${json?.s}`).html(
            `<span class=${Number(json?.P).toFixed(2) > 0 ? "tr-green" : "tr-red"
            } >${Number(json?.p).toFixed(2)}</span>`
          );
          $(`.24hpc-${json?.s}`).html(
            `<span class=${Number(json?.P).toFixed(2) > 0 ? "tr-green" : "tr-red"
            } >${Number(json?.P).toFixed(2) + "%"}</span>`
          );
          $(`.open-${json?.s}`).html(Number(json?.o).toFixed(2));
          $(`.vol-${json?.s}`).html(Number(json?.v).toFixed(2));
          $(`.high-${json?.s}`).html(Number(json?.h).toFixed(2));
          $(`.low-${json?.s}`).html(Number(json?.l).toFixed(2));
        } catch (error) {
          console.log(error, "err");
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket Error:", error);
      };

      ws.onclose = () => {
        console.log("WebSocket Connection Closed");
      };

      return () => {
        console.log("Cleaning up WebSocket connection");
        ws.close();
      };
    } catch (error) {
      console.log("🚀 ~ currentSocket ~ error:", error);
    }
  };

  useEffect(() => {
    if (allPairs.length > 0) {
      currentSocket();
    }
  }, [allPairs]);

  return (
    <div>
      <div className="market-full homepage">
        <Header />
        {/* <Loader/> */}
        <section className="hbanner">
          {/* <div className="contain-width"> */}
          <Grid
            container
            sx={{
              alignItems: "center !important",
              height: lg ? "100%" : "80%",
              p: lg ? 3 : 1,
            }}
            className={lg && "linear"}
          >
            <Grid
              items
              xs={12}
              sm={12}
              md={12}
              lg={6}
              xl={6}
            // sx={{ margin: "auto" }}
            >
              <div className="the-first media-letter">
                The First Exchange to Combine Crypto, Futures & Music Assets
                <div className="the-p" style={{ marginBottom: '20px' }}>
                  Trade cryptocurrencies, futures contracts, and even music
                  rights - all on one platform.
                </div>
                {localStorage.getItem("Rikosta") ? (
                  <div className="sign-new">
                    <Button onClick={() => navigate("/dashboard")}>
                      Dashboard
                    </Button>
                  </div>
                ) : (
                  <div className="sign-new">
                    <Button onClick={() => navigate("/register")}>
                      Sign up
                    </Button>
                  </div>
                )}
              </div>
            </Grid>
            {lg && (
              <Grid
                items
                xs={12}
                sm={12}
                md={12}
                lg={6}
                xl={6}
              // sx={{ margin: "auto" }}
              >
                <div class="crypto-container">
                  <img
                    src={!isLightMode ? bannerDK : bannerLg}
                    class="center-image"
                  />
                  <div class="orbit teth"></div>
                  <div class="orbit eth"></div>
                  <div class="orbit btc"></div>
                </div>
              </Grid>
            )}
          </Grid>
          <Grid
            container
            sx={{ height: "100%", p: 0 }}
          // className="linear"
          >
            <Grid
              items
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              sx={{ paddingBottom: "50px" }}
              className="sect-2"
            >
              <div className="abt-sec p-20">Features</div>
              <div className="display-3 flex-wrap mt-30">
                <div className="ft-c">
                  <div className="ft-h">Trade 1000+ Tokens</div>
                  <div className="ft-p">
                    Trade thousands of crypto assets with ease.
                  </div>
                  <div className="mt-20 ic-btn">
                    <svg
                      width="55"
                      height="55"
                      viewBox="0 0 55 55"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.28027 7.17444V43.1034C7.28027 44.2945 7.75344 45.4368 8.59569 46.2791C9.43794 47.1213 10.5803 47.5945 11.7714 47.5945H47.7003"
                        stroke="#C084FC"
                        stroke-width="4.49112"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M40.9639 38.6122V20.6477"
                        stroke="#C084FC"
                        stroke-width="4.49112"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M29.7358 38.6124V11.6656"
                        stroke="#C084FC"
                        stroke-width="4.49112"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M18.5078 38.6123V31.8756"
                        stroke="#C084FC"
                        stroke-width="4.49112"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <div className="ft-c">
                  <div className="ft-h">Futures Trading</div>
                  <div className="ft-p">
                    Go long or short with crypto futures for advanced
                    strategies.
                  </div>
                  <div className="mt-20 ic-btn">
                    <svg
                      width="55"
                      height="55"
                      viewBox="0 0 55 55"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M47.6897 36.3667H38.7075C37.4673 36.3667 36.4619 37.3721 36.4619 38.6123V47.5945C36.4619 48.8347 37.4673 49.8401 38.7075 49.8401H47.6897C48.9299 49.8401 49.9353 48.8347 49.9353 47.5945V38.6123C49.9353 37.3721 48.9299 36.3667 47.6897 36.3667Z"
                        stroke="#C084FC"
                        stroke-width="4.49112"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16.2517 36.3667H7.26948C6.0293 36.3667 5.02393 37.3721 5.02393 38.6123V47.5945C5.02393 48.8347 6.0293 49.8401 7.26948 49.8401H16.2517C17.4919 49.8401 18.4973 48.8347 18.4973 47.5945V38.6123C18.4973 37.3721 17.4919 36.3667 16.2517 36.3667Z"
                        stroke="#C084FC"
                        stroke-width="4.49112"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M31.9705 4.92896H22.9882C21.748 4.92896 20.7427 5.93433 20.7427 7.17451V16.1567C20.7427 17.3969 21.748 18.4023 22.9882 18.4023H31.9705C33.2107 18.4023 34.216 17.3969 34.216 16.1567V7.17451C34.216 5.93433 33.2107 4.92896 31.9705 4.92896Z"
                        stroke="#C084FC"
                        stroke-width="4.49112"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M11.7607 36.3668V29.6301C11.7607 29.0345 11.9973 28.4634 12.4185 28.0422C12.8396 27.6211 13.4107 27.3845 14.0063 27.3845H40.953C41.5486 27.3845 42.1197 27.6211 42.5409 28.0422C42.962 28.4634 43.1986 29.0345 43.1986 29.6301V36.3668"
                        stroke="#C084FC"
                        stroke-width="4.49112"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M27.48 27.3845V18.4022"
                        stroke="#C084FC"
                        stroke-width="4.49112"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <div className="ft-c">
                  <div className="ft-h">Stake Tokens</div>
                  <div className="ft-p">
                    Stake your holdings to earn rewards and support the network.
                  </div>
                  <div className="mt-20 ic-btn">
                    <svg
                      width="55"
                      height="54"
                      viewBox="0 0 55 54"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M36.4105 47.1568V42.6657C36.4105 40.2835 35.4641 37.9988 33.7796 36.3143C32.0951 34.6298 29.8105 33.6835 27.4282 33.6835H13.9549C11.5727 33.6835 9.28799 34.6298 7.60349 36.3143C5.919 37.9988 4.97266 40.2835 4.97266 42.6657V47.1568"
                        stroke="#C084FC"
                        stroke-width="4.49112"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M20.6922 24.7013C25.6529 24.7013 29.6744 20.6798 29.6744 15.7191C29.6744 10.7583 25.6529 6.73682 20.6922 6.73682C15.7314 6.73682 11.71 10.7583 11.71 15.7191C11.71 20.6798 15.7314 24.7013 20.6922 24.7013Z"
                        stroke="#C084FC"
                        stroke-width="4.49112"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M49.8841 47.1569V42.6658C49.8827 40.6756 49.2203 38.7423 48.0009 37.1694C46.7816 35.5964 45.0744 34.473 43.1475 33.9755"
                        stroke="#C084FC"
                        stroke-width="4.49112"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M36.4106 7.02869C38.3428 7.52339 40.0553 8.64706 41.2782 10.2226C42.5011 11.7981 43.1649 13.7358 43.1649 15.7302C43.1649 17.7247 42.5011 19.6624 41.2782 21.2379C40.0553 22.8134 38.3428 23.9371 36.4106 24.4318"
                        stroke="#C084FC"
                        stroke-width="4.49112"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="display-3 flex-wrap">
                <div className="ft-c">
                  <div className="ft-h">Buy Crypto with Card</div>
                  <div className="ft-p">
                    Buy crypto instantly with your credit or debit card via our
                    secure payment gateway.
                  </div>
                  <div className="mt-20 ic-btn">
                    <svg
                      width="49"
                      height="49"
                      viewBox="0 0 49 49"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M49 15.5996V13.0156C49 10.0557 46.6005 7.65625 43.6406 7.65625H5.35938C2.39947 7.65625 0 10.0557 0 13.0156V15.5996C0 15.8638 0.214279 16.0781 0.478516 16.0781H48.5215C48.7857 16.0781 49 15.8638 49 15.5996Z"
                        fill="#C084FC"
                      />
                      <path
                        d="M0 19.6191V35.9844C0 38.9443 2.39947 41.3438 5.35938 41.3438H43.6406C46.6005 41.3438 49 38.9443 49 35.9844V19.6191C49 19.3549 48.7857 19.1406 48.5215 19.1406H0.478516C0.214279 19.1406 0 19.3549 0 19.6191ZM12.25 32.1562C12.25 33.0019 11.5644 33.6875 10.7188 33.6875H9.1875C8.34187 33.6875 7.65625 33.0019 7.65625 32.1562V30.625C7.65625 29.7794 8.34187 29.0938 9.1875 29.0938H10.7188C11.5644 29.0938 12.25 29.7794 12.25 30.625V32.1562Z"
                        fill="#C084FC"
                      />
                    </svg>
                  </div>
                </div>
                <div className="ft-c">
                  <div className="ft-h">Music Asset Marketplace</div>
                  <div className="ft-p">
                    Buy and trade music rights and NFTs through our Dreamster
                    Music link.
                  </div>
                  <div className="mt-20 ic-btn">
                    <svg
                      width="42"
                      height="46"
                      viewBox="0 0 32 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.1047 5.50208V23.6005C9.05161 22.6611 7.66386 22.0891 6.14482 22.0891C2.86104 22.0891 0.189453 24.7607 0.189453 28.0446C0.189453 31.3284 2.86104 34 6.14482 34C9.42455 34 12.0933 31.3351 12.1001 28.057H12.1003V13.512L29.8146 9.02154V18.7962C28.7614 17.8567 27.3737 17.2848 25.8547 17.2848C22.5708 17.2848 19.8993 19.9564 19.8993 23.2402C19.8993 26.524 22.5708 29.1956 25.8547 29.1956C29.1385 29.1956 31.8101 26.5239 31.8101 23.2402V0L10.1047 5.50208Z"
                        fill="#C084FC"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid
              items
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              // sx={{ margin: "auto" }}c
              className="sect-3 home_market"
            >
              <div className="abt-sec c2 p-20 ">Live Market Prices</div>
              <div className="p-20">
                <div className="mt-20  market-list">
                  <div className="p-20 display-2 media_dis2">
                    <div className="display-1 gap media_dev">
                      <div className="stat-txt p-20">Market List </div>
                      {/* <div className="table-srch">
                      <BasicTextFields
                        placeholder="Search tokens..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div> */}
                    </div>
                    <div className="display-1 basicselect media_dis1 mt-10">
                      {/* <BasicSelect
                      value={selectedValue}
                      handleChange={handleSelectChange}
                      items={dropdownItems}
                      label={"Select"}
                      sx={{ minWidth: "200px" }}
                    /> */}
                      {/* <BasicSelect
                      value={selectedValue2}
                      handleChange={handleSelectChange2}
                      items={dropdownItems2}
                      label={"Select"}
                      sx={{ minWidth: "200px" }}
                    />
                    <Filter /> */}
                    </div>
                  </div>
                  {/* <div className="dash-table">
                    <ReusableTable collections={collections} />
                  </div> */}
                  <div className="market-table">
                    <TableContainer sx={{ marginBottom: "10px" }}>
                      <Table
                        sx={{
                          minWidth: 650,
                          [`& .${tableCellClasses.root}`]: {
                            borderBottom: "none",
                          },
                        }}
                        aria-label="simple table"
                        className="market-table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">#</TableCell>
                            <TableCell align="left">Name</TableCell>
                            <TableCell align="center">Price</TableCell>
                            <TableCell align="center">
                              <span className="highlight-text">24h </span>{" "}
                              changes
                            </TableCell>
                            <TableCell align="center">24h High</TableCell>
                            <TableCell align="center">24h Low</TableCell>
                            <TableCell align="center">24h Volume</TableCell>
                            <TableCell align="center">Action</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {currentPairs?.length > 0 ? (
                            currentPairs?.map((row, index) => (
                              <TableRow className="tr_row" key={index}>
                                <TableCell align="center">
                                  {" "}
                                  <span>{index + 1}</span>
                                  {/* <Checkbox
                                                  {...label}
                                                  icon={<StarOutlineRoundedIcon />}
                                                  checkedIcon={<StarOutlineRoundedIcon />}
                                                /> */}
                                </TableCell>
                                <TableCell>
                                  <div className="d-flex align-items-center gap-10">
                                    <div>
                                      <ImageWithFallback
                                        src={row?.icon}
                                        name={row?.base_asset_name}
                                        alt="coin-img"
                                      />
                                    </div>
                                    <div>{row?.base_asset_name}</div>
                                  </div>
                                </TableCell>
                                <TableCell align="center">
                                  <span
                                    className={`price-${row?.base_asset_name}USDT`}
                                  >
                                    {Number(row?.last)}
                                  </span>
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={
                                    row.change?.includes("-")
                                      ? { color: "#F65454" }
                                      : { color: "#1A8F5C" }
                                  }
                                >
                                  <span
                                    className={`change-${row?.base_asset_name
                                      }USDT ${Number(row?.changeRate * 100) >= 0
                                        ? "green"
                                        : "red"
                                      }`}
                                  >
                                    {Number(row?.changeRate * 100)?.toFixed(2)}{" "}
                                    %
                                  </span>
                                </TableCell>
                                <TableCell align="center">
                                  <span
                                    className={`high-${row?.base_asset_name}USDT`}
                                  >
                                    {row?.high}
                                  </span>
                                </TableCell>
                                <TableCell align="center">
                                  <span
                                    className={`low-${row?.base_asset_name}USDT`}
                                  >
                                    {row?.low}
                                  </span>
                                </TableCell>
                                <TableCell align="center">
                                  <span
                                    className={`volume-${row?.base_asset_name}USDT`}
                                  >
                                    {Number(row?.vol)?.toFixed(2)}
                                  </span>
                                </TableCell>
                                <TableCell align="center">
                                  {/* <Button variant="text" className="highlight-text">
                                                  Details
                                                </Button> */}
                                  <Button
                                    variant="text"
                                    className="highlight-text"
                                    onClick={() => {
                                      navigate(
                                        `/trade/${row?.base_asset_name}_USDT`
                                      );
                                    }}
                                  >
                                    Trade
                                  </Button>{" "}
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow className="tr_row ">
                              <TableCell align="center" colSpan={8}>
                                <img src={nodata} alt="nodata" />
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
              <Footernew />
            </Grid>
          </Grid>
          {/* </div> */}
        </section>
      </div>
    </div>
  );
};

export default HomeNew;
